'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _tagListLocal = require('./tag-list.local.css');

var _tagListLocal2 = _interopRequireDefault(_tagListLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TagList = function (_React$Component) {
  _inherits(TagList, _React$Component);

  function TagList(props) {
    _classCallCheck(this, TagList);

    var _this = _possibleConstructorReturn(this, (TagList.__proto__ || Object.getPrototypeOf(TagList)).call(this, props));

    _this.focusInput = function () {
      if (_this.props.hasInputField && _this.state.hasFocus && _this.inputRef.current) {
        _this.inputRef.current.focus();
      }
    };

    _this.timeOutId = null;
    _this.inputRef = _react2.default.createRef();
    _this.state = {
      hasFocus: false,
      rotate: 0
    };
    return _this;
  }

  _createClass(TagList, [{
    key: 'renderClearAllTagsButton',
    value: function renderClearAllTagsButton() {
      return this.props.hideClearAllTagsButton || !this.props.children || !this.props.children.length ? null : _react2.default.createElement(_icon2.default, {
        'aria-label': this.props.removeAllButtonTitle,
        onClick: this.props.onClearAllTagsClick,
        className: _tagListLocal2.default.clearAllButton,
        icon: 'reload',
        type: 'clearAllTagsButton'
      });
    }
  }, {
    key: 'renderCaretButton',
    value: function renderCaretButton() {
      return this.props.children && this.props.children.length ? _react2.default.createElement(_icon2.default, {
        onClick: this.props.onClickedIcon,
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        rotate: this.state.rotate,
        customStyling: {
          zIndex: 99
        },
        className: _tagListLocal2.default.caretButton,
        icon: 'caret'
      }) : null;
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'renderInputField',
    value: function renderInputField() {
      return this.props.hasInputField ? _react2.default.createElement('input', {
        className: (0, _classnames2.default)(_tagListLocal2.default.inputField, this.state.hasFocus ? undefined : _tagListLocal2.default.inputFieldHidden),
        spellCheck: false,
        type: 'text',
        'aria-autocomplete': 'list',
        'aria-haspopup': 'false',
        autoCapitalize: 'off',
        autoCorrect: 'off'
        /* eslint-disable-next-line */
        ,
        role: 'combobox',
        'aria-label': 'Search',
        title: 'Search',
        name: 'new tag name input',
        onChange: this.props.onInputFieldChange,
        value: this.props.inputValue,
        ref: this.inputRef
        /* this prevents Chrome from auto-completing and hiding our custom autocomplete, may be whack-a-mole situation */
        ,
        autoComplete: this.props.autoComplete || 'off'
      }) : null;
    }
  }, {
    key: 'renderLoader',
    value: function renderLoader() {
      return this.props.children === undefined || !this.props.children.length ? _react2.default.createElement('div', {
        style: {
          height: '1.1em'
        }
      }, _react2.default.createElement('div', {
        className: _tagListLocal2.default.loader
      })) : null;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.hasFocus && this.props.hasInputField) {
        this.focusInput();
      } else if (this.state.hasFocus) {
        if (this.parentRef) this.parentRef.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classes = [_tagListLocal2.default.base, this.props.className];
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)(classes, _tagListLocal2.default.tagList),
        role: 'button',
        tabIndex: 0,
        onClick: this.focusInput,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        onKeyDown: this.props.onKeyDown,
        ref: function ref(element) {
          _this2.parentRef = element;
        }
      }, this.renderLoader(), this.renderCaretButton(), this.renderClearAllTagsButton(), this.props.children, this.renderInputField());
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(newProps) {
      return {
        hasFocus: newProps.hasFocus,
        rotate: newProps.hasFocus ? 180 : 0
      };
    }
  }]);

  return TagList;
}(_react2.default.Component);

TagList.defaultProps = {
  hasInputField: true,
  removeAllButtonTitle: 'Remove All Items',
  onInputFieldChange: function onInputFieldChange() {},
  onClearAllTagsClick: function onClearAllTagsClick() {},
  onClickedIcon: function onClickedIcon() {},
  onKeyDown: function onKeyDown() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  inputValue: ''
};
TagList.propTypes = {
  /**
   * Pass in true if you want to hide the clear 'X' button
   */
  hideClearAllTagsButton: _propTypes2.default.bool,

  /**
   * Sets the value of `inputField` which is a controlled input.
   */
  inputValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * The function called when the clear all tags button is pressed.
   */
  onClearAllTagsClick: _propTypes2.default.func,

  /**
   * The function called when the clear all tags button is pressed.
   */
  onKeyDown: _propTypes2.default.func,

  /**
   * Listen for keyboard keyDown and trigger prop function.
   */
  onFocus: _propTypes2.default.func,

  /**
   * Trigger prop function when component is focused.
   */
  onBlur: _propTypes2.default.func,

  /**
   * Trigger prop function when component is blurred.
   */
  onInputFieldChange: _propTypes2.default.func,
  hasInputField: _propTypes2.default.bool,

  /**
   * ClassName will insert styles to override defaults
   */
  className: _propTypes2.default.string,

  /**
   * Pass info to parent that the icon has been clicked.
   */
  autoComplete: _propTypes2.default.string,

  /**
   * Pass a value for the autoComplete property of the input tag
   */
  onClickedIcon: _propTypes2.default.func,

  /**
   * The title to give TagList's 'remove all' button; used for accessibility.
   */
  removeAllButtonTitle: _propTypes2.default.string,

  /**
   * All children must be Tag component instances.
   */
  children: function children(props, propName, componentName) {
    var prop = props[propName];

    _react2.default.Children.forEach(prop, function (child) {
      if (child && child.type && child.type.name !== 'Tag') {
        throw new Error(componentName + ' only accepts children of type \'Tag\'.');
      }
    });
  }
};
exports.default = TagList;